<div class="modal fade" id="record-type-info-modal" tabindex="-1">
  <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Activity type info</h5>
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p>
          Please use the correct activity type according to these rules:
        </p>
        <ul>
          <li><b>Event:</b> use only for physical events</li>
          <li><b>Talk:</b> use for talks that are not by Utopia or The Watcher Post</li>
          <li><b>UTOPIA Studios - URANIA:</b> use only for our formats performed in the Studios</li>
        </ul>
      </div>
    </div>
  </div>
</div>